<template>
    <div id="input-modal" class="text-center">
        <button type="button" class="close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
        </button>
        <h6 class="mt-3 mb-3 ml-2 mr-2"
            :class="{'mt-3': true, 'mb-3': true, 'ml-2': true, 'mr-2': true, 'warning': warning}">{{heading}}</h6>
        <div class="form-group">
            <input v-model="name" style="width: 90%; margin: 0 auto;" class="form-control" type="text"
                   :placeholder="placeholderName">
        </div>
        <div class="form-group">
            <formatted-input :value="value" 
                             :disabled="false"
                             @emit-value="updateValue"
                             style="width: 90%; margin: 0 auto;">
            </formatted-input>
            <!-- <input v-model="value" style="width: 90%; margin: 0 auto;" class="form-control" step="0.01" type="number"
                    :placeholder="placeholderValue"> -->
            <!-- <input id="input-amount" v-bind="money"
                   type="number"
                   step="0.01"
                   v-model="value"
                   style="width: 90%; margin: 0 auto;"
                   class="form-control"/> -->
        </div>
        <div>
            <button @click="addCategory" class="btn btn-primary btn-block">OK</button>
        </div>
    </div>
</template>

<script>
import FormattedInput from '../cms/misc/FormattedInput'

  export default {
    name: 'InputModal',
    props: ['heading', 'label', 'placeholderValue', 'placeholderName', 'type', 'event', 'is_additional', 'warning'],
    data () {
      return {
        name: '',
        value: 0
      }
    },
    components:{
      FormattedInput
    },
    created () {
      // if (!this.warning) {
      //   this.warning = false
      // }
      //
      // if (!this.is_additional) {
      //   this.is_additional = false
      // }
    },
    methods: {
      updateValue(variable){
        this.value = variable;
      },
      addCategory () {
        this.$emit(this.event, {
          name: this.name,
          type: this.type,
          value: this.value,
          is_additional: this.is_additional,
        })

        this.$emit('close')
      },
      closeModal () {
        this.$emit('close')
      },
      // setCaretPos () {
      //   const elem = document.getElementById('input-amount')
      //
      //   elem.addEventListener('click', function (event) {
      //     console.log(event.target.setSelectionRange(0,0));
      //   })
      //
      // }
    }
  }
</script>

<style scoped>

    .warning {
        color: rgba(255, 0, 0, 0.6);
    }

    .close {
        margin-right: 10px;
        margin-top: -5px;
    }

</style>